module.exports = __webpack_public_path__ + "static/media/terminal-receipt.909be42b.jpg";